<template>
  <div class="col-start align-stretch">
    <Header :is-wide="true" />
    <div class="container grow">

      <div class="main-no-side">

        <el-result
          :icon="icon"
          :title="title"
          :sub-title="desc"
        >
          <!-- <template slot="extra">
            <el-button type="default" @click="onBack">返回</el-button>
          </template> -->
        </el-result>
      </div>
    </div>
    <!-- <Footer :is-wide="true" /> -->
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
// import Footer from '@/components/Footer.vue'

export default {
  name: 'Result',
  components: {
    Header
    // Footer
  },
  data() {
    return {
      type: 'error',
      title: '页面未找到(404)',
      desc: ''
    }
  },
  computed: {
    icon() {
      switch (this.type) {
        case 'success':
          return 'success'
        case 'warning':
          return 'warning'
        case 'error':
          return 'error'
        case 'info':
          return 'info'
        default:
          return 'info'
      }
    }
  },
  watch: {
    // order: {
    //   // eslint-disable-next-line no-unused-vars
    //   handler(newValue, oldValue) {
    //     // this.calcCost(this.order)
    //   },

    //   deep: true
    // }
  },
  created() {
    if (this.$route.query.type) {
      this.type = this.$route.query.type
    }
    if (this.$route.query.title) {
      this.title = decodeURIComponent(this.$route.query.title)
    }

    if (this.$route.query.desc) {
      this.desc = decodeURIComponent(this.$route.query.desc)
    }
  },
  async mounted() {
  },
  methods: {
    onBack() {
      this.$router.go(-1)
    }
  }
}
</script>
